import { World } from "./world";
import { UNIT_DEFS } from "../data";
import { KIND_UNIT } from "./constants";

const SPOT_SNAP = 34;

export function nearestFreeSpot(w: World, x: number, y: number, maxDist = SPOT_SNAP): number {
  const spots = w.gmap.def.metalSpots;
  let best = -1;
  let bestD = maxDist;
  for (let i = 0; i < spots.length; i++) {
    if (w.metalSpotOccupant[i] >= 0) continue;
    const d = Math.hypot(spots[i].x - x, spots[i].y - y);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  }
  return best;
}

/** Snap a proposed placement to its final position (extractors go to spots). */
export function placePos(w: World, defId: string, x: number, y: number): { x: number; y: number } {
  const def = UNIT_DEFS[defId];
  if (def.role === "extractor") {
    const s = nearestFreeSpot(w, x, y);
    if (s >= 0) return { x: w.gmap.def.metalSpots[s].x, y: w.gmap.def.metalSpots[s].y };
  }
  return { x, y };
}

/** Is `defId` legally placeable at (x,y)? Used by the sim and the ghost UI. */
export function canPlace(w: World, defId: string, x: number, y: number): boolean {
  const def = UNIT_DEFS[defId];
  if (def.kind !== "building") return false;
  // Bounds.
  const m = w.gmap;
  if (x < m.cellSize * 2 || y < m.cellSize * 2 || x > m.worldW - m.cellSize * 2 || y > m.worldH - m.cellSize * 2) {
    return false;
  }
  if (def.role === "extractor") {
    return nearestFreeSpot(w, x, y) >= 0;
  }
  // No overlap with existing solid entities (buildings, wreckage, features).
  for (let e = 0; e < w.count; e++) {
    if (!w.alive[e]) continue;
    const solid = w.kind[e] !== KIND_UNIT;
    if (!solid) continue;
    const odef = w.def(e);
    const min = def.radius + odef.radius - 2;
    if (Math.hypot(w.posX[e] - x, w.posY[e] - y) < min) return false;
  }
  return true;
}
